<template>
  <div>
    <div class="modal fade " tabindex="-1" role="dialog" id="modalAddFile">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
              aria-hidden="true">×</span></button>
            <h4 class="modal-title"> Ajouter un fichier</h4>
          </div>
          <div class="modal-body">
            <UploadFiles
              :urlPost="urlUploadFile"
              @filesUploaded="allFilesUploaded()"
              morph="club"
              :id_morph="getClub.id"
            ></UploadFiles>
          </div>
          <div class="modal-footer">
            <button type="button"
                    class="btn btn-default pull-right" data-dismiss="modal">
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-alert v-if="getClub.isLicencie" variant="success" show>Ce club est en ordre de licence pour
      {{ getClub.licence_active.annee }}
    </b-alert>
    <b-alert v-if="!getClub.isLicencie" variant="warning" show>Ce club n'est pas en ordre de licence</b-alert>

    <form role="form">
      <div class="row">
        <div class="col-md-6">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Logo</h3>
            </div>
            <div class="box-body">
              <div class="col-md-12">
                <img
                  class="img-thumbnail"
                  v-if="getClub.logo"
                  width="200"
                  height="200"
                  :src="getClub.logo">
              </div>
              <div class="col-md-12">
                <a class="btn btn-primary btn-flat margin "
                   @click="show_upload_logo=!show_upload_logo">Importer
                  logo
                </a>

                <a class="btn btn-primary btn-flat margin " v-if="getClub.logo" @click="getClub.logo=null">
                  Enlever <br/>ce logo
                </a>
              </div>
              <my-upload field="img"
                         @crop-success="cropSuccess"
                         @crop-upload-success="cropUploadSuccess"
                         @crop-upload-fail="cropUploadFail"
                         v-model="show_upload_logo"
                         :width="300"
                         :height="300"
                         langType="fr"
                         :noCircle="true"
                         img-format="jpg">
              </my-upload>
            </div>
          </div>

          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Données administratives</h3>
              <button type="button"
                      class="btn btn-xs btn-danger btn-flat margin pull-right"
                      style="margin-top: 0;margin-bottom: 0;"
                      @click="supprimerClub()"
              >
                Supprimer le club
              </button>

            </div>
            <div class="box-body">
              <div class="form-group"
                   :class="{'has-error': numclubexist!=null }"
              >
                <label for="numero">Numéro de club</label>
                <!--//TODO Chech si numero du club est libre lorsqu'on le modifie-->
                <input type="text" class="form-control" id="num_club"
                       name="club[numero_club]"
                       @keyup="checkIfNumeroClubExist()"
                       placeholder="Numéro du club"
                       v-model="getClub.numero_club"
                       v-validate="'required|numeric'"
                       :disabled="true"
                >

                <!--<span v-if="numclubexist!=null"-->
                <!--class="help-block">Ce numéro est déjà pris par le club  {{numclubexist.club}}</span>-->
                <!--<span v-if="numLibre==true && numclubexist==null"-->
                <!--class="help-block">Ce numéro est valable</span>-->

                <!--<span v-show="errors.has('club[numero_club]')"-->
                <!--class="help-block">Numéro de club incorrect</span>-->
              </div>

              <div class="form-group">
                <label for="province">Province</label>
                <select id="province" class="form-control" name="club[id_province]"
                        v-model="getClub.province.id">
                  <option
                    v-for="province in getProvinces"
                    :value="province.id"
                  > {{ province.province }}
                  </option>
                </select>
                <!--<span class="help-block">Help block with error</span>-->
              </div>

              <div class="form-group"
                   :class="{'has-error': errors.has('club[club]') }">
                <label for="nom">Nom</label>
                <input type="text" class="form-control" id="nom" name="club[club]"
                       v-validate="'max:255'"
                       placeholder="Nom du club" v-model="getClub.club">
                <span v-show="errors.has('club[club]')" class="help-block">Le nom du club doit comporter moins de 255 caractères</span>
              </div>


              <div class="form-group"
                   :class="{'has-error': errors.has('club[adresse]') }">
                <label for="adresse">Rue et numéro du siège</label>
                <textarea class="form-control"
                          rows="3"
                          id="adresse"
                          name="club[adresse]"
                          v-model="getClub.adresse"
                          v-validate="'max:255'"
                          placeholder="Adresse du club...">
                                </textarea>
                <span v-show="errors.has('club[adresse]')" class="help-block">L'adresse doit comporter moins de 255 caractères</span>
              </div>

              <cp-and-ville
                :cpProp="this.getClub.cp"
                :villeProp="this.getClub.ville"
                placeholder_cp="Code postal du club"
                placeholder_ville="Ville du club"
                @villeChanged="setVilleClub"
                @cpChanged="setcpClub"
              >
              </cp-and-ville>

              <div class="form-group">
                <label for="ville">Pays</label>
                <select class="form-control" name="club[pays]" v-model="getClub.pays">
                  <option value="ZZ">Pays
                    indéterminé
                  </option>
                  <optgroup label="Habituels">
                    <option
                      v-for="pays in getPays.habituels"
                      :value="pays.id"
                    >{{ pays.name }}
                    </option>

                  </optgroup>
                  <optgroup label="Autres">
                    <option
                      v-for="pays in getPays.all"
                      :value="pays.id"
                    > {{ pays.name }}
                    </option>
                  </optgroup>
                </select>
                <!--<span class="help-block">Help block with error</span>-->
              </div>

              <div class="form-group"
                   :class="{'has-error': errors.has('club[numero_compte]') }">
                <label for="numcompte">Numéro de compte</label>
                <input type="text" class="form-control" id="numcompte" name="club[numero_compte]"
                       v-validate="'max:255'"
                       placeholder="Numéro de compte du club" v-model="getClub.numero_compte">
                <span v-show="errors.has('club[numero_compte]')" class="help-block">Le numéro de compte ne doit pas dépasser les 255 caractères</span>
              </div>

              <div class="form-group"
                   :class="{'has-error': errors.has('club[site_web]') }">
                <label for="site_web">Site web</label>
                <input type="text" class="form-control" id="site_web" name="club[site_web]"
                       v-validate="'url'"
                       placeholder="Site web du club" v-model="getClub.site_web">
                <span v-show="errors.has('club[site_web]')" class="help-block">L'adresse du site web doit être une URL valide</span>
              </div>

              <div class="form-group"
                   :class="{'has-error': errors.has('club[structure]') }">
                <div>
                  <label for="structure">Structure légale</label>
                  <div class="radio">
                    <label>
                      <input type="radio" :name="'getClub[structure]'" value="asbl"
                             v-model="getClub.structure">
                      ASBL
                    </label>
                  </div>
                  <div class="radio">
                    <label>
                      <input type="radio" :name="'getClub[structure]'" value="associationfait"
                             v-model="getClub.structure">
                      Association de fait
                    </label>
                  </div>
                  <div class="radio">
                    <label>
                      <input type="radio" :name="'getClub[structure]'" value="unknown"
                             v-model="getClub.structure">
                      Inconnue
                    </label>
                  </div>
                </div>
              </div>

              <div class="form-group"
                   :class="{'has-error': errors.has('club[bce]') }">
                <label for="site_web">Numéro BCE</label>
                <input type="text" class="form-control" id="site_web" name="club[bce]"
                       placeholder="Numéro BCE du club" v-model="getClub.bce">
              </div>

            </div>
          </div>

          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Données de contact</h3>
            </div>
            <div class="box-body">
              <div class="form-group" :class="{'has-error': errors.has('club[mail]') }">
                <label for="mail">E-mail</label>
                <input type="mail" class="form-control" id="email" name="club[mail]"
                       v-validate="'email'"
                       placeholder="Email du club"
                       v-model="getClub.mail"
                >
                <span v-show="errors.has('club[mail]')"
                      class="help-block">Adresse mail incorrecte</span>
              </div>

              <div class="form-group" :class="{'has-error': errors.has('club[tel]') }">
                <label for="telephone">Téléphone</label>
                <input type="text" class="form-control" id="telephone" name="club[tel]"
                       placeholder="Téléphone du club"
                       v-model="getClub.tel"
                >
                <span v-show="errors.has('club[tel]')" class="help-block">Numéro de téléphone incorrect</span>
              </div>

              <div class="form-group" :class="{'has-error': errors.has('club[gsm]') }">
                <label for="gsm">GSM</label>
                <input type="text" class="form-control" id="gsm" name="club[gsm]"
                       placeholder="GSM du club"
                       v-model="getClub.gsm"
                >
                <span v-show="errors.has('club[gsm]')"
                      class="help-block">Numéro de GSM incorrect</span>
              </div>

            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Données supplémentaires</h3>
            </div>
            <div class="box-body">
              <div class="col-md-6">
                <div class="form-group">
                  <div class="checkbox">
                    <label for="adeps">
                      <input id="adeps" name="club[adeps]" type="checkbox"
                             v-model="getClub.adeps">
                      Club ADEPS
                    </label>
                  </div>

                  <div class="checkbox">
                    <label for="scolaire">
                      <input id="scolaire" name="club[club_scolaire]" type="checkbox"
                             v-model="getClub.club_scolaire">
                      Club scolaire
                    </label>
                  </div>

                  <div class="checkbox">
                    <label for="cours_enfant">
                      <input id="cours_enfant" name="club[cours_enfant]" type="checkbox"
                             v-model="getClub.cours_enfant">
                      Propose des cours pour enfants
                    </label>
                  </div>

                  <div class="checkbox">
                    <label for="fbft">
                      <input id="fbft" name="club[fbft]" type="checkbox"
                             v-model="getClub.fbft">
                      Club FBFT
                    </label>
                  </div>

                  <div class="checkbox">
                    <label for="ubft">
                      <input id="ubft" name="club[ubft]" type="checkbox"
                             v-model="getClub.ubft">
                      Club UBFT
                    </label>
                  </div>

                </div>
              </div>

              <div class="col-md-6">
                <div class="radio">
                  <label for="taekwondo">
                    <input id="taekwondo" name="club[type]" value="taekwondo" type="radio"
                           v-model="typeClub">
                    Club Taekwondo
                  </label>
                </div>

                <div class="radio">
                  <label for="tangsoodo">
                    <input id="tangsoodo" name="club[type]" value="tangsoodo" type="radio"
                           v-model="typeClub">
                    Club Tangsoodo
                  </label>
                </div>

                <div class="radio">
                  <label for="hapkido">
                    <input id="hapkido" name="club[type]" value="hapkido" type="radio"
                           v-model="typeClub">
                    Club Hapkido
                  </label>
                </div>
                <div class="radio">
                  <label for="haedong">
                    <input id="haedong" name="club[type]" value="haedong" type="radio"
                           v-model="typeClub">
                    Club Haedong Kumdo
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Affichage</h3>
            </div>
            <div class="box-body">
              <div>
                <label for="radiowww">Site Web </label>
                <div class="radio">
                  <label>
                    <input type="radio" :name="'getClub[affichage_site]'" value="1"
                           v-model="getClub.affichage_site">
                    Afficher sur https://www.abft.be
                  </label>
                </div>
                <div class="radio">
                  <label>
                    <input type="radio" :name="'getClub[affichage_site]'" value="0"
                           v-model="getClub.affichage_site">
                    Ne pas afficher sur le site
                  </label>
                </div>
              </div>

              <div>
                <label for="radiowww">Ranking</label>
                <div class="radio">
                  <label>
                    <input type="radio" :name="'getClub[affichage_ranking]'" value="1"
                           v-model="getClub.affichage_ranking">
                    Afficher sur le ranking
                  </label>
                </div>
                <div class="radio">
                  <label>
                    <input type="radio" :name="'getClub[affichage_ranking]'" value="0"
                           v-model="getClub.affichage_ranking">
                    Ne pas afficher sur le ranking
                  </label>
                </div>
              </div>

              <div>
                <label for="radiowww">Correspondant</label>
                <div class="radio">
                  <label>
                    <input type="radio" :name="'getClub[affichage_correspondant]'" value="1"
                           v-model="getClub.affichage_correspondant">
                    Afficher les coordonnées du correspondant
                  </label>
                </div>
                <div class="radio">
                  <label>
                    <input type="radio" :name="'getClub[affichage_correspondant]'" value="0"
                           v-model="getClub.affichage_correspondant">
                    Afficher les coordonnées de cette fiche
                  </label>
                </div>
              </div>

              <div>
                <label for="radiowww">Adresse du club</label>
                <div class="radio">
                  <label>
                    <input type="radio" :name="'getClub[affichage_adresse_siege_club]'" value="1"
                           v-model="getClub.affichage_adresse_siege_club">
                    Afficher l'adresse du siège du club
                  </label>
                </div>
                <div class="radio">
                  <label>
                    <input type="radio" :name="'getClub[affichage_adresse_siege_club]'" value="0"
                           v-model="getClub.affichage_adresse_siege_club">
                    Masquer l'adresse du siège du club
                  </label>
                </div>
              </div>
              <div>
                <label for="radiowww">Expédition</label>
                <div class="radio">
                  <label>
                    <input type="radio" :name="'getClub[choix_adresse_expedition]'" :value="0"
                           v-model="choix_adresse_expedition">
                    Utiliser l'affichage classique
                    <ul>
                      <li>Nom du club</li>
                      <li>Nom du correspondant</li>
                      <li>Adresse du correspondant</li>
                      <li>Ville du correpsondant</li>
                    </ul>
                  </label>
                </div>
                <div class="radio">
                  <label>
                    <input type="radio" :name="'getClub[choix_adresse_expedition]'" :value="1"
                           v-model="choix_adresse_expedition">
                    Utiliser une adresse personnalisée
                    <p>
                    <textarea
                      v-show="choix_adresse_expedition"
                      v-model="getClub.adresse_expedition"
                      style="width: 400px; min-height: 250px" row="10" cols="10">

                    </textarea>
                    </p>
                  </label>
                </div>
              </div>


            </div>
          </div>

          <div class="box box-primary">

            <div class="box-header with-border">
              <h3 class="box-title">Comité</h3>
            </div>

            <div class="box-body">
              <div class="form-group"
                   v-for="(value) in orderPoste">
                   <div v-if="getPosteClubByMeta(value)">
                <label :for="value">{{ getPosteClubByMeta(value).poste }}</label>
                <v-select v-model="getClub.comite_complet_for_vselect[value]"
                          multiple
                          label="fullName"
                          :filterable="false"
                          :debounce="250"
                          :on-search="SearchMembersResponse"
                          :options="ArrayMembersSearch">

                                <span slot="selected-option" slot-scope="props">
                                    <router-link
                                      :to="{ name: 'Member', params: { member_id: props.selectedOption.id }}">
                                        {{ props.selectedOption.fullName }}
                                    </router-link>
                                </span>
                  <span slot="option" slot-scope="props">
                                    <span :class="props.item.licencie? 'text-green' : 'text-red'">{{
                                        props.item.fullName
                                      }}</span>
                                 </span>
                </v-select>
                <div v-for="member in getClub.comite_complet_for_vselect[value]"
                  v-if="!member.isCasierJudiciaireValid"
                >
                  <span style="color:red">{{member.fullName}} ne possède pas d'extrait de casier judiciaire en ordre</span>
                </div>
                </div>
              </div>
            </div>
          </div>

          <div class="box box-primary">
            <div class="overlay" v-if="loadingSecretariat">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-header with-border">
              <h3 class="box-title">Secrétariat</h3>
            </div>
            <div class="box-body">
              <div class="form-group clearfix">
                <label>Récapitulatif et impression</label>
                <p>
                  <router-link
                    type="button"
                    class="btn btn-primary btn-flat col-xs-4 margin"
                    :to="{ name: 'Recap', params: { recap_id: 0,filterClub:getClub.id }}">
                    Listing des récapitulatifs
                  </router-link>

                  <button type="button"
                          @click.prevent="showModal('#modalAddFile')"
                          class="btn btn-primary btn-flat col-xs-4 margin">Ajouter un
                    fichier
                  </button>
                </p>
              </div>

              <div class="form-group clearfix">
                <label>Secrétariat</label>
                <p>
                  <button type="button"
                          class="btn btn-primary btn-flat col-xs-4 margin"
                          @click.prevent="printEtiquetteEnvoi()">
                    Imprimer l'étiquette d'envoi
                  </button>
                  <button type="button"
                          class="btn btn-primary btn-flat col-xs-4 margin"
                          @click.prevent="etiquetteIndividuelleClubForFlyer(moment().year())">
                    Imprimer une feuille d'étiquette pour flyers
                  </button>
                  <button type="button"
                          class="btn btn-primary btn-flat col-xs-4 margin"
                          @click.prevent="getFicheClubWord()">
                    Fiche d'analyse de club (WORD)
                  </button>
                </p>
              </div>

              <!--<div class="form-group clearfix">-->
              <!--<label>Licence 2017</label>-->
              <!--<p>-->
              <!--<button type="button" class="btn btn-primary btn-flat col-xs-4 margin">Imprimer-->
              <!--l'étiquette (individuelle) 2017-->
              <!--</button>-->
              <!--<button type="button" class="btn btn-primary btn-flat col-xs-4 margin">-->
              <!--Imprimer la carte-->
              <!--annuelle de licence 2017-->
              <!--</button>-->
              <!--</p>-->
              <!--</div>-->

            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-md-12">

          <div class="box box-primary" v-if="loadingDojangs">
            <div class="box-header">
              <h3 class="box-title">Chargement en cours</h3>
            </div>
            <div class="box-body">
              Chargement des dojangs
            </div>
            <div class="overlay">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>


          <div class="nav-tabs-custom"
               v-if="!loadingDojangs"
          >
            <button type="button"
                    class="btn btn-small btn-danger btn-flat margin pull-right"
                    @click="supprimerDojang()"
                    v-show="activeDojang!=null"
            >
              Supprimer ce dojang
            </button>
            <button type="button"
                    class="btn btn-small btn-primary btn-flat margin pull-right"
                    v-if="activeDojang!=null"
                    :class="[(activeDojang.adresse=='' || activeDojang.cp=='') ? 'disabled' : '']"
                    :disabled="(activeDojang.adresse=='' || activeDojang.cp=='')"
                    @click="calculateCoordinate()"
            >
              Calculer les coordonnées
            </button>

            <ul class="nav nav-tabs">
              <li v-for="(dojang,index) in getClub.dojangs"
                  v-if="!dojang.delete"
                  :class="[activeTab=='djn'+dojang.id ? 'active' : '']">
                <a :href="'#'+dojang.id"
                   @click.prevent="setActiveDojang(dojang)"
                   class="googlemapdojang"
                >Dojang {{ index + 1 }}</a>
              </li>
              <li>
                <a :href="'#0'"
                   @click.prevent="addNewDojang()"
                   class="googlemapdojang"
                ><i class="fa fa-plus-circle"></i> Nouvau Dojang</a>
              </li>
            </ul>
            <div class="tab-content">
              <div v-for="(dojang,index) in getClub.dojangs"
                   v-show="activeTab=='djn'+dojang.id"
                   class="tab-pane " :class="[activeTab=='djn'+dojang.id ? 'active' : '']"
                   :id="dojang.id">
                <dojang
                  :dojang="dojang"
                  :activeTab="activeTab"
                  :redraw="redraw"
                ></dojang>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="nav-tabs-custom">
            <ul class="nav nav-tabs">
              <li class="active">
                <a href="#tab_1" data-toggle="tab" aria-expanded="true">Logs</a>
              </li>
              <li class="">
                <a href="#tab_2" data-toggle="tab" aria-expanded="false">Dossiers de suivi</a>
              </li>
              <li class="">
                <a href="#tab_3" data-toggle="tab" aria-expanded="false">Fichiers liés</a>
              </li>
            </ul>

            <div class="tab-content">
              <div class="tab-pane active" id="tab_1">
                <b-table
                  responsive bordered striped hover
                  :items="getClub.log"
                  :fields="columns"
                  :current-page="pagination_meta.current_page"
                  :per-page="pagination_meta.per_page"
                  :empty-text="'Aucun résultat'"
                  :empty-filtered-text="'Aucun résultat'"
                  foot-clone
                  show-empty
                >
                  <template slot="id" slot-scope="row">
                    {{ row.item.id | idFormat }}
                  </template>
                  <template slot="user" slot-scope="data">
                    <span>{{ data.item.user }}</span>
                  </template>
                  <template slot="fullDescription" slot-scope="data">
                    <span v-html="data.item.fullDescription"></span>
                  </template>
                </b-table>

                <b-pagination size="md"
                              :total-rows="getClub.log.length"
                              v-model="pagination_meta.current_page"
                              :per-page="pagination_meta.per_page">
                </b-pagination>
              </div>

              <!-- /.tab-pane -->
              <div class="tab-pane" id="tab_2">
                Vide pour l'instant
              </div>
              <!-- /.tab-pane -->

              <div class="tab-pane " id="tab_3">
                <b-table
                  id="tableFilesMember"
                  responsive bordered striped hover
                  :items="getClub.file"
                  :fields="filesOptions.columns"
                  :current-page="filesOptions.pagination_meta.current_page"
                  :per-page="filesOptions.pagination_meta.per_page"
                  :empty-text="'Aucun résultat'"
                  :empty-filtered-text="'Aucun résultat'"
                  foot-clone
                  show-empty
                >
                  <template slot="created_at" slot-scope="row">
                    {{ row.item.date }}
                  </template>
                  <template slot="link" slot-scope="row">
                    <a :href="getProcessEnv.STORAGE_URL+row.item.nom" target="_blank">
                      {{ row.item.titre }}
                    </a>
                  </template>
                </b-table>
                <b-pagination size="md"
                              :total-rows="getClub.file.length"
                              v-model="filesOptions.pagination_meta.current_page"
                              :per-page="filesOptions.pagination_meta.per_page">
                </b-pagination>
              </div>
              <!-- /.tab-pane -->
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="box ">
            <div class="overlay"
                 v-if="this.disabledBtn"
            >
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-body">
            </div>
            <div class="box-footer">
              <button type="button"
                      class="btn btn-lg btn-primary btn-flat margin pull-right"
                      :disabled="errors.count()!=0 || !this.numLibre || this.disabledBtn || this.loadingInputs.length>0"
                      @click="sendForm()"
              >
                Enregistrer les modifications
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {ErrorBag} from 'vee-validate';
import Datepicker from 'vuejs-datepicker';
import vSelect from '../../Communs/vSelect/index'
import cropUpload from '../../Communs/ImgCropUpload'
import cpAndVille from '../../Communs/cpAndVille'
import dojang from './Dojang'
import UploadFiles from '../../Communs/UploadFiles'

var $ = require('jquery');
var variables = require('../../../assets/js/variables')
var _ = require('underscore')
var moment = require('moment')
var FileSaver = require('file-saver');

export default {
  data() {
    return {
      loadingDojangs: false,
      show_upload_logo: false,
      loadingSecretariat: false,
      villeTemp: null,
      numclubexist: null,
      numLibre: true,
      loadingInputs: [],
      ArrayMembersSearch: [],
      disabledBtn: false,
      resize: false,
      activeTab: "default",
      activeDojang: null,
      dataTableLogClub: null,
      dataTableFilesClub: null,
      redraw: "",
      urlUploadFile: '',
      addFileUpload: null,
      typeClub: 'taekwondo',
      choix_adresse_expedition: 0,
      filesOptions: {
        columns: [
          {
            label: 'Date',
            key: 'created_at',
            sortable: true,
          },
          {
            label: 'Link',
            key: 'link',
            sortable: true,
          },
          {
            label: 'Nom',
            key: 'titre',
            sortable: false,
          },
          {
            label: 'Responsable',
            key: 'user',
            sortable: true,
          },
        ],
        pagination_meta: {
          current_page: 1,
          from: 1,
          last_page: 1,
          path: "",
          per_page: 40,
          to: 1,
          total: 1
        },
      },
      pagination_meta: {
        current_page: 1,
        from: 1,
        last_page: 1,
        path: "",
        per_page: 20,
        to: 1,
        total: 1
      },
      columns: [
        {
          label: 'Identifiant',
          sortable: true,
          key: 'id'
        },
        {
          label: 'Date',
          sortable: false,
          key: 'date'
        },
        {
          label: 'Description',
          sortable: false,
          key: 'fullDescription'
        },
        {
          label: 'Auteur',
          sortable: true,
          key: 'user'
        },
      ]
    }
  },
  computed: {
    ...mapGetters({
      getProfessions: 'getProfessions',
      getRoute: 'getRoute',
      getPostes: 'getPostes',
      getVilles: 'getVilles',
      getStatutsSportifs: 'getStatutsSportifs',
      getPays: 'getPays',
      getProvinces: 'getProvinces',
      getClub: 'getClub',
      getProcessEnv: 'getProcessEnv',
    }),
    orderPoste: function () {
      return ['president', 'secretaire', 'correspondant', 'tresorier', 'moniteur','moniteur_adjoint', 'membre_sportif', 'referent_ethique']
    }
  },
  mounted: function () {
    var these = this
    this.urlUploadFile = this.getRoute('Secretariat.addFile');
    this.setTypeClub()
    this.$nextTick(function () {
      setTimeout(function () {
        these.refreshListings()
        these.choix_adresse_expedition = these.getClub.adresse_expedition && these.getClub.adresse_expedition != "" ? 1 : 0
        // these.getClub.adresse_expedition=these.getClub.adresse_expedition && these.getClub.adresse_expedition != "" ? 1 : 0
      }, 1000)
    })
  },
  created() {
    if (this.getClub.dojangs.length > 0) {
      this.activeTab = 'djn' + this.getClub.dojangs[0].id
      this.activeDojang = this.getClub.dojangs[0]
    }
    this.checkIfNumeroClubExist = _.debounce(this.checkIfNumeroClubExist, 300);
  },
  watch: {
    // 'typeClub': function () {
    //     if (this.getClub.taekwondo == true) {
    //         this.getClub.hapkido = 0
    //         this.getClub.tangsoodo = 0
    //     }
    // },
  },
  components: {
    vSelect,
    UploadFiles,
    cpAndVille: cpAndVille,
    dojang,
    'my-upload': cropUpload
  },
  methods: {
    ...mapActions({}),
    setTypeClub: function () {
      if (this.getClub) {
        if (this.getClub.taekwondo)
          this.typeClub = 'taekwondo'
        if (this.getClub.tangsoodo)
          this.typeClub = 'tangsoodo'
        if (this.getClub.hapkido)
          this.typeClub = 'hapkido'
        if (this.getClub.haedong)
          this.typeClub = 'haedong'
      } else
        this.typeClub = 'taekwondo'
    },
    showModal: function (id) {

      $(id).modal('show')
    },
    closeModal: function (id) {
      $(id).modal('hide')
    },
    allFilesUploaded: function () {
      this.closeModal("#modalAddFile")
      this.refreshClubFiles()
    },
    refreshClubFiles: function () {
      this.$http.get(this.getRoute('getFilesClub') + this.getClub.id)
        .then((response) => {
          this.getClub.file = response.body.file
        }, (response) => {
        });
    },
    refreshListings: function () {
      this.dataTableLogClub = $("#logClub").DataTable({
        language: variables.dt_french(),
        "paging": true,
        "ordering": true,
        "info": true,
        "autoWidth": true,
      });
      this.dataTableFilesClub = $("#filesClub").DataTable({
        language: variables.dt_french(),
        "paging": true,
        "ordering": true,
        "info": true,
        "autoWidth": true,
      });
    },
    getRandomInt: function (min, max) {
      let id = Math.floor(Math.random() * (max - min + 1)) + min;
      if (_.findWhere(this.getClub.dojangs, {id: id}))
        return this.getRandomInt();
      return id;
    },
    addNewDojang: function () {
      let self = this
      this.loadingDojangs = true
      this.$http.post(this.getRoute('Secretariat.club.createDojang') + this.getClub.id, this.constructForm())
        .then(function (response) {
          self.$noty.success("Dojang ajouté")
          let newDojang = response.body
          this.getClub.dojangs.push(newDojang)
          this.setActiveDojang(newDojang)
          this.disabledBtn = false
          this.loadingDojangs = false
        }, (response) => {
          self.$consoleLog(_.values(response.body.errors))
          _.values(response.body.errors).forEach(function (item, index) {
            item.forEach(function (item2, index) {
              self.$noty.error(item2)
            })
          })
          this.disabledBtn = false
          this.loadingDojangs = false
        });
    },
    constructForm: function () {
      return JSON.stringify({
        "numero_club": this.getClub.numero_club,
        "club": this.getClub.club,
        "id_province": this.getClub.province.id,
        "numero_compte": this.getClub.numero_compte,
        "site_web": this.getClub.site_web,
        "bce": this.getClub.bce,
        "structure": this.getClub.structure,
        "adresse": this.getClub.adresse,
        "cp": this.getClub.cp,
        "ville": this.getClub.ville,
        "pays": this.getClub.pays,
        "tel": this.getClub.tel,
        "mail": this.getClub.mail,
        "gsm": this.getClub.gsm,
        "affichage_correspondant": this.getClub.affichage_correspondant,
        "affichage_adresse_siege_club": this.getClub.affichage_adresse_siege_club,
        "affichage_site": this.getClub.affichage_site,
        "affichage_ranking": this.getClub.affichage_ranking,
        "adresse_expedition": this.choix_adresse_expedition ? this.getClub.adresse_expedition : "",
        "adeps": this.getClub.adeps,
        "club_scolaire": this.getClub.club_scolaire,
        "cours_enfant": this.getClub.cours_enfant,
        "taekwondo": this.typeClub == 'taekwondo' ? 1 : 0,
        "tangsoodo": this.typeClub == 'tangsoodo' ? 1 : 0,
        "hapkido": this.typeClub == 'hapkido' ? 1 : 0,
        "haedong": this.typeClub == 'haedong' ? 1 : 0,
        "fbft": this.getClub.fbft,
        "ubft": this.getClub.ubft,
        "dojangs": this.constructDojangsForm(),
        "logo": this.getClub.logo,
        "comite": this.getClub.comite_complet_for_vselect,
        // "logo_base64": this.getClub.logo,
      })
    },
    constructDojangsForm: function () {
      let dojangs = [];
      let these = this;
      this.getClub.dojangs.forEach(function (item, index, array) {
        let dojang = {
          'id': item.id,
          'id_club': these.getClub.id,
          'complement_adresse': item.complement_adresse ? item.complement_adresse : '',
          'adresse': item.adresse ? item.adresse : '',
          'cp': item.cp ? item.cp : '',
          'ville': item.ville ? item.ville : '',
          'pays': item.pays ? item.pays : '',
          'longitude': item.longitude ? item.longitude : '',
          'latitude': item.latitude ? item.latitude : '',
          'DEA': item.DEA ? item.DEA : 0,
          "DEA_formation_dates": item.DEA_formation_dates ? item.DEA_formation_dates : [],
          'horaires': these.constructHoraireForm(item)
        }
        dojangs.push(dojang)
      })
      return dojangs
    },
    supprimerClub: function () {
      let self = this
      this.$dialog.confirm('' +
        'Confirmez-vous la suppression de ce club ?<br/><br/> ' +
        'Toutes les comités, licences club, dojangs, fichiers seront supprimés. Les participations aux compétitions sous ce club devront être réassignées. Les membres enregistré sous ce club devront être réassignés. ',
        {
          html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
          loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
          reverse: false, // switch the button positions (left to right, and vise versa)
          okText: 'Supprimer le club',
          cancelText: 'Annuler',
          animation: 'zoom', // Available: "zoom", "bounce", "fade"
          type: 'basic', // coming soon: 'soft', 'hard'
        })
        .then(function (dialog) {
          setTimeout(() => {
            self.$http.delete(self.getRoute('Secretariat.club.destroy') + self.getClub.id)
              .then(function (response) {
                self.$noty.success("Club supprimé")
                self.$router.push('/');
                dialog.close();
              }, (response) => {
                self.$noty.success("Erreur dans la suppression")
                dialog.close();
              });
          }, 1000);
        })
        .catch(function () {
          // console.log('Clicked on cancel')
        });
    },

    constructHoraireForm: function (dojang) {
      let horaires = [];
      if (_.isUndefined(dojang.horaires))
        return horaires
      dojang.horaires.forEach(function (item, index, array) {
        let horaire = {
          "id": item.id ? item.id : '',
          "nouveau": item.nouveau ? item.nouveau : false,
          "delete": item.delete ? item.delete : false,
          "id_dojang": dojang.id,
          "debut": item.debut ? item.debut : '',
          "description": item.description ? item.description : '',
          "fin": item.fin ? item.fin : '',
          "jour": item.jour ? item.jour : '',
        }
        horaires.push(horaire)
      })
      return horaires
    },
    cropSuccess(imgDataUrl, field) {
      this.getClub.logo = imgDataUrl;
    },
    cropUploadSuccess(jsonData, field) {
    },
    cropUploadFail(status, field) {
    },
    setActiveDojang: function (dojang) {
      this.activeTab = 'djn' + dojang.id
      this.activeDojang = dojang
    },
    getAdress: function (dojang) {
      return dojang.adresse + "-" + dojang.cp + " " + dojang.ville
    },
    printEtiquetteEnvoi: function () {
      let these = this;
      this.loadingSecretariat = true
      this.$http.post
      (
        this.getRoute('Secretariat.etiquetteIndividuelleClub'),
        JSON.stringify({"id_club": this.getClub.id}),
        {responseType: 'blob'}
      ).then(function (response) {
        this.loadingSecretariat = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, these.getClub.id + "_etiquette.pdf");
        return response.blob();

      }, (response) => {
        these.$noty.error("Erreur dans la génération de l'étiquette")

      });
    },
    moment: function () {
      return moment()
    },
    etiquetteIndividuelleClubForFlyer: function (date) {
      if (!date)
        return;
      let self = this;
      this.loadingSecretariat = true
      this.$http.post
      (
        self.getRoute('Secretariat.etiquetteIndividuelleClubForFlyer'),
        JSON.stringify({
          year: date,
          id_club: this.getClub.id
        }),
        {responseType: 'blob'}
      ).then((response) => {
        this.loadingSecretariat = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, "Etiquettes_" + this.getClub.id + "_" + date + ".pdf");
        return response.blob();
      }, (response) => {
        self.$noty.error("Erreur dans la génération du fichier ")
        this.loadingSecretariat = false
      });
    },

    getFicheClubWord: function () {
      let these = this;
      this.loadingSecretariat = true
      this.$http.post
      (
        this.getRoute('exportFicheAnalyseClub'),
        JSON.stringify({"ids_club": this.getClub.id + ","}),
        {responseType: 'blob'}
      ).then(function (response) {
        this.loadingSecretariat = false
        let blob = new Blob([response.body], {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'})
        FileSaver.saveAs(blob, these.getClub.id + "_ficheAnalyseClub.docx");
        return response.blob();
      }, (response) => {
        these.$noty.error("Erreur dans la génération de la fiche d'analyse club")
        this.loadingSecretariat = false
      });
    },
    calculateCoordinate: function () {
      let these = this
      let geocoder = new google.maps.Geocoder();
      let address = this.getAdress(this.activeDojang);
      geocoder.geocode({'address': address}, function (results, status) {
        if (status == 'OK') {
          these.activeDojang.latitude = results[0].geometry.location.lat()
          these.activeDojang.longitude = results[0].geometry.location.lng()
          these.redraw = "" + results[0].geometry.location.lat()
          these.$noty.success("Coordonnées calculées")
        } else {
          these.$noty.error("Erreur Google Map: " + status)
        }
      });
    },
    supprimerDojang: function () {
      let these = this
      let self = this
      this.$http.post(this.getRoute('Secretariat.club.destroyDojang') + this.activeDojang.id, this.constructForm())
        .then(function (response) {
          self.$noty.success("Dojang supprimé")
          let dojangToDel = _.findWhere(these.getClub.dojangs, {id: these.activeDojang.id});
          these.$consoleLog(dojangToDel)
          these.getClub.dojangs = _.without(these.getClub.dojangs, dojangToDel);
          these.disabledBtn = false
          these.loadingDojangs = false
          this.activeTab = null;
          this.activeDojang = null
        }, (response) => {
          self.$consoleLog(_.values(response.body.errors))
          _.values(response.body.errors).forEach(function (item, index) {
            item.forEach(function (item2, index) {
              self.$noty.error(item2)
            })
          })
          these.disabledBtn = false
          these.loadingDojangs = false
        });
    },
    getPosteClubByMeta: function (meta) {
      return _.findWhere(this.getPostes, {poste_meta: meta});
    },
    SearchMembersResponse: function (search, loading) {
      if (search.length <= 2)
        return;
      loading(true)
      this.$http.post(this.getRoute("memberSearch"), {q: search}).then(resp => {
        loading(false)
        this.ArrayMembersSearch = resp.data
        this.ArrayMembersSearch = _.where(this.ArrayMembersSearch, {licencie: true}).concat(_.where(this.ArrayMembersSearch, {licencie: false}))
      })
    },
    sendForm: function () {
      this.disabledBtn = true;
      let self = this;
      this.$http.put(this.getRoute('Secretariat.club.update') + this.getClub.id, this.constructForm()).then(function (response) {
        self.$noty.success("La fiche du club a bien été modifiée")
        this.disabledBtn = false
        self.getClub.dojangs = response.body.dojangs
      }, (response) => {
        self.$consoleLog(_.values(response.body.errors))
        _.values(response.body.errors).forEach(function (item, index) {
          item.forEach(function (item2, index) {
            self.$noty.error(item2)
          })
        })
        this.disabledBtn = false
      });
    },
    isInputLoading: function (input) {
      return _.indexOf(this.loadingInputs, input) >= 0 ? true : false

    },
    addToLoadingInputs: function (input) {
      this.loadingInputs.push(input)
    },
    removeFromLoadingInputs: function (input) {
      this.loadingInputs = _.without(this.loadingInputs, input)
    },
    checkIfNumeroClubExist: function () {
      this.removeFromLoadingInputs('numero_club')
      this.addToLoadingInputs('numero_club')
      var these = this;
      this.$http.post(this.getRoute('checkIfNumeroClubExist'), {
        id_club: these.getClub.id,
        numero_club: these.getClub.numero_club,
      }, {
        // use before callback
        before(request) {
          // abort previous request, if exists
          if (this.previousRequest) {
            this.previousRequest.abort();
          }
          // set previous request on Vue instance
          this.previousRequest = request;
        }
      }).then((response) => {
        // these.$consoleLog(response.body)
        this.numclubexist = _.isEmpty(response.body) ? null : response.body
        this.numLibre = this.numclubexist == null ? true : false
        this.removeFromLoadingInputs('numero_club')
      }, (response) => {
        self.$noty.error("Erreur dans la vérification du numéro du club")
        this.removeFromLoadingInputs('numero_club')
      });
    },
    setVilleClub: function (value) {
      this.getClub.ville = value;
    },
    setcpClub: function (value) {
      this.getClub.cp = value;
    },

  },
  filters: {
    idFormat: function (value) {
      return new Intl.NumberFormat("de-DE").format(value)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Club/MainFormClub.vue